var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('Tracking'),_c('b-col',{staticClass:"text-center"},[_c('h2',{staticClass:"text-primary",staticStyle:{"margin-top":"30px"}},[_vm._v("Aguarde, vamos direcionar você para o grupo no whatsapp")]),_c('br'),_c('spinner')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }